import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4471_1831)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.7861 9.16863C17.7861 8.43117 17.7263 7.89303 17.5968 7.33496H9.17578V10.6634H14.1187C14.0191 11.4906 13.4809 12.7363 12.285 13.5734L12.2683 13.6848L14.9308 15.7475L15.1153 15.7659C16.8094 14.2013 17.7861 11.8992 17.7861 9.16863Z",
				fill: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.17549 17.9384C11.5971 17.9384 13.6301 17.1411 15.115 15.7659L12.2848 13.5734C11.5274 14.1015 10.5109 14.4703 9.17549 14.4703C6.80368 14.4703 4.79064 12.9057 4.07304 10.7432L3.96786 10.7521L1.19929 12.8947L1.16309 12.9954C2.63799 15.9252 5.66755 17.9384 9.17549 17.9384Z",
				fill: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.07269 10.7431C3.88334 10.185 3.77376 9.58704 3.77376 8.9692C3.77376 8.35129 3.88334 7.75338 4.06273 7.19531L4.05771 7.07645L1.25445 4.89941L1.16273 4.94304C0.554856 6.15886 0.206055 7.52419 0.206055 8.9692C0.206055 10.4142 0.554856 11.7795 1.16273 12.9953L4.07269 10.7431Z",
				fill: "#1D1D1D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.17549 3.46802C10.8597 3.46802 11.9957 4.19551 12.6435 4.80346L15.1748 2.33196C13.6202 0.886946 11.5971 0 9.17549 0C5.66755 0 2.63799 2.01305 1.16309 4.94292L4.06308 7.19519C4.79064 5.03265 6.80368 3.46802 9.17549 3.46802Z",
				fill: "#1D1D1D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4471_1831",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 17.5878,
			height: 18,
			fill: "white",
			transform: "translate(0.206055)"
		})
	}) })]
});
export default SvgGoogleLogo;
